<section aria-labelledby="employer-logo" class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column gap-3"></div>
  <h3 class="self-enrolment-header" id="employer-logo" i18n>Employer Logo</h3>
  <div i18n class="paragraph-md">
    You may optionally upload and crop a logo for your organization. Supplying a logo creates a company-branded
    experience within SPP for the Employer Users and Employee Members.
  </div>
  <div class="d-flex flex-column gap-2">
    <app-file-upload-field
      [accept]="['image/png', 'image/jpeg']"
      [submitAttempted]="formSubmitted"
      [formControl]="fileControl"
      [control]="fileControl"
      [showThumbnail]="true"
      (selectedFilesChanged)="handleFileChange($event)">
      <ng-container input-copy>
        <img height="24" [src]="'assets/icons/blue/UploadFile.svg'" alt="" />
        <app-file-uploader-text
          instructionText="Upload a file or drag and drop a .png or .jpeg"
          i18n-instructionText
          descriptionText="Up to 3 MB"
          i18n-descriptionText />
      </ng-container>
    </app-file-upload-field>
    <div *ngIf="!fileControl.value?.length" i18n class="form-input-hint">Optional</div>
  </div>
</section>
